import React from 'react';
import Badge, { Props as BadgeProps } from '../badge/badge';
import { BadgeStyles } from '../badge/badge.scss';

import defaultStyles from './highlighted-badge.scss';

export default (props: Omit<BadgeProps, 'styles'> & { style?: Partial<BadgeStyles> }) => (
    <Badge style={{ badge: defaultStyles.badge }} {...props} />
);
